export const FORBIDDEN_SYMBOLS_WITH_NO_SPACES_REGEX = /[-=±/!@#$%^&*()_+{}\[\]:;<>,.?~\\|'"`]/;
export const FORBIDDEN_SYMBOLS_WITH_SPACES_REGEX = /[-=±/!@#$%^&*()_+{}\[\]:;<>,.?~\\|'"` ]/;
export const FORBIDDEN_SYMBOLS_WITH_NO_NUMBERS_REGEX = /[-=±/!@#$%^&*()_+{}\[\]:;<>,.?~\\|'"`0-9]/;

export const TELEGRAM_VALIDATOR_PATTERN = /^[a-zA-Z0-9_@]+$/;
export const ZIPCODE_VALIDATOR_PATTERN = /^[a-zA-Z0-9-]+$/;
export const EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const SPRIBE_EMAIL_REGEXP = /^[a-zA-Z0-9._%+-]+@spribe\.co$/;
export const SLACK_REGEXP = /^https:\/\/[a-zA-Z0-9_-]+\.slack\.com(\/.*)?$/;
export const TEAMS_REGEXP = /^https:\/\/teams\.microsoft\.com\/[a-zA-Z0-9/?=&%\-_.]+$/;
export const DIGITS_ONLY_REGEXP = /\D/g;
export const SIGNED_INTEGER_PATTERN = /^-?\d+$/;

export const IDENTIFIER_WITH_UNDERSCORE_REGEXP = /^[A-Za-z0-9_-]+$/;
export const PROVIDER_ID_REGEXP = /^[A-Za-z0-9-]+$/;
export const PROVIDER_NAME_REGEXP = /^[a-zA-Z0-9\- ]+$/;

export const OPERATOR_KEY_VALIDATOR_PATTERN = /^(?!.*__)(?!.*_$)[a-z][a-z0-9_]{2,10}$/;

export const COMMUNICATION_CHANNEL_NAME_REGEXP = /^[\x20-\x7E]+$/;

export const ISO_DURATION_REGEX = /^P(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?$/;

export const LATIN_WITH_SPECIAL_CHARS_PATTERN = /^[\p{Script=Latin}\d\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/u;
